export default "__VITE_ASSET__5efdf538__"